// extracted by css-extract-rspack-plugin
export default {"cls1":"ClaimEvaluationRow-cls1_cFS","cls2":"ClaimEvaluationRow-cls2_rVR ClaimEvaluationRow-cls1_cFS"};